import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { reducer as formReducer } from 'redux-form'
import * as reducers from '../reducers'

const reducer = combineReducers({...reducers, form: formReducer})
const store = (initialState={}) => createStore(reducer, initialState, applyMiddleware(thunkMiddleware))

export default store()
